import React, { useEffect, useState } from 'react';
import { Row } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import Form, { FormInstance } from 'antd/lib/form';
import ParListSelect from 'components/ParListSelect';
import ThirdPartyInput from 'components/ThirdPartyInput';
import FormItem from 'antd/es/form/FormItem';
import BankAccountListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/BankAccListSelect';
import AddresseListSelect from 'pages/ThirdParty/ThirdPartyDetail/Components/AddressesListSelect';

export type TabTPProps = {
  objectid?: number;
  form?: FormInstance;
};

const TabAddTp = ({ form }: any) => {
  const [newRole, setRole] = useState('');

  useEffect(() => {
    form?.setFieldsValue({
      event: 'tabAddTp',
      tpadrid: form.getFieldValue('address'),
    });
  }, [form]);

  return (
    <DF.Provider pagcode="tabaddtp">
      <Form form={form} layout="horizontal" labelCol={{ span: 24 }}>
        <Row gutter={16}>
          <FormInput
            comcode="tprolecode"
            name="tprolecode"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect
              parcode="ADDITIROL"
              onSelect={(e) => {
                setRole(e);
              }}
            />
          </FormInput>
          <FormInput comcode="tpid" name="tpid" col xs={6} shouldUpdate>
            <ThirdPartyInput role={newRole} />
          </FormInput>
        </Row>
        <Row gutter={16}>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput comcode="tpbkidin" name="tpbkidin" col xs={6}>
                <BankAccountListSelect
                  params={{
                    tpid: getFieldValue('tpid')?.tpid,
                  }}
                />
              </FormInput>
            )}
          </FormItem>
          <FormInput
            comcode="tppaymodein"
            name="tppaymodein"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYMODEIN" />
          </FormInput>

          <FormInput
            comcode="tppaydelayin"
            name="tppaydelayin"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYDELAYIN" />
          </FormInput>

          {/* <FormInput name="tpmandatedate" col xs={6} shouldUpdate>
              <DatePicker />
            </FormInput> */}
        </Row>
        <Row gutter={16}>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                comcode="bankAccountOut"
                name="tpbkidout"
                col
                xs={6}
                shouldUpdate
              >
                <BankAccountListSelect
                  params={{
                    tpid: getFieldValue('tpid')?.tpid,
                  }}
                />
              </FormInput>
            )}
          </FormItem>

          <FormInput
            comcode="tppaymodeout"
            name="tppaymodeout"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYMODEOUT" />
          </FormInput>
          <FormInput
            comcode="tppaydelayout"
            name="tppaydelayout"
            col
            xs={6}
            shouldUpdate
          >
            <ParListSelect parcode="PAYDELAYOU" />
          </FormInput>
        </Row>
        <Row gutter={16}>
          <FormItem shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                comcode="address"
                name="address"
                col
                xs={6}
                shouldUpdate
              >
                <AddresseListSelect
                  params={{
                    tpid: getFieldValue('tpid')?.tpid,
                  }}
                />
              </FormInput>
            )}
          </FormItem>
        </Row>
      </Form>
    </DF.Provider>
  );
};
export default TabAddTp;
